import { login, logout, getUserRole } from '@/api/user';
import { getToken, setToken, removeToken, removeRoles } from '@/utils/auth';

const state = {
  token: getToken(),
  roles: ''
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  }
};

const actions = {
  // 登录
  login ({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        let accessToken = response.token;
        commit('SET_TOKEN', accessToken);
        setToken(accessToken);
        resolve();
      }).catch(error => {
        console.log(error);
        reject(error);
      });
    });
  },

  // 权限
  getUserRoles ({ commit }) {
    return new Promise((resolve, reject) => {
      getUserRole().then(response => {
        commit('SET_ROLES', JSON.stringify(response));
        // setRoles(JSON.stringify(response));
        resolve();
      }).catch(error => {
        console.log(error);
        reject(error);
      });
    });
  },

  // 退出
  logout ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', '');
        removeToken();
        removeRoles();
        resolve();
      }).catch(error => {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', '');
        removeToken();
        removeRoles();
        reject(error);
      });
    });
  },

  // 401清除信息
  clearInfo ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', '');
      removeToken();
      removeRoles();
      reject(error);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js